import { render, staticRenderFns } from "./AddFakturPage.vue?vue&type=template&id=767cee28&scoped=true&"
import script from "./AddFakturPage.vue?vue&type=script&lang=js&"
export * from "./AddFakturPage.vue?vue&type=script&lang=js&"
import style0 from "./AddFakturPage.vue?vue&type=style&index=0&id=767cee28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767cee28",
  null
  
)

export default component.exports